import { render, staticRenderFns } from "./AddQuizQuestionModal.vue?vue&type=template&id=e63212aa&scoped=true&"
import script from "./AddQuizQuestionModal.vue?vue&type=script&lang=ts&"
export * from "./AddQuizQuestionModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddQuizQuestionModal.vue?vue&type=style&index=0&id=e63212aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63212aa",
  null
  
)

export default component.exports